import React, { FC, ReactElement } from "react";
import styled from "styled-components";

interface Props {
  children: ReactElement;
}

const InputScreenButtonGroupWrap: FC<Props> = ({ children }) => {
  return <Wrap>{children}</Wrap>;
};

const Wrap = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 184px) minmax(auto, 184px);
  justify-content: space-between;
  grid-gap: 16px;
`;

export default InputScreenButtonGroupWrap;
